export default {"src":"/_next/static/media/check-white.ba123ced.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};